export default function render(parameter, parameterValue) {
  const {original_value: value, unit} = parameterValue;
  return `${value} ${unit}${value > 1 ? "s" : ""}`;
}
